import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconCopy2SVG } from './IconCopy2SVG';

export function IconCopy2({ ...props }: UseIconProps) {
  const iconProps = useIcon(props);
  return <Box tagName={IconCopy2SVG} {...iconProps} />;
}
